import React from 'react';
import styled from 'styled-components';

const Button = ({ onSubmit, text }) => (
  <Container>
      <ContainerSection>
        <ButtonContainer>
          <button
            style={{
              backgroundColor: '#37b8ca',
              borderRadius: '4px',
              fontWeight: '500',
              height: '70px',
              fontFamily: '"Karla", sans-serif;',
              fontSize: '20px',
              color: 'white',
            }}
            type="submit"
            onClick={onSubmit}
          >{text}</button>
        </ButtonContainer>
      </ContainerSection>
    </Container>
);

const Container = styled.div`
    display: flex;
    justify-content: center;
`;

const ContainerSection = styled.div`
    margin: 25px;
    justify-content: center;
    flex-wrap: wrap;
    width: 945px;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export default Button;



// WEBPACK FOOTER //
// ./client/redesign/signup/components/StartButton/index.js